import styles from '../../styles/document-view-styles';

export default {
  root: styles.root,
  title: styles.title,
  body: styles.body,
  bodyContainer: styles.bodyContainer,
};
